import React, { memo } from 'react';
import { LoanService } from '../../services';
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import WatchLater from '@material-ui/icons/WatchLater';
import { useError } from '../../contexts/ErrorContext';

const MarkHoldsAsProcessingButton = ({selectedRowIndices, holds}) => {
    const { showError } = useError();
    const handleMarkAsProcessingClick = async () => {
        const paymentIds = selectedRowIndices.map(rowId => holds[rowId].paymentHeldIds).flat();

        try{
            const response = await LoanService.markHoldsAsProcessing(paymentIds);
            if (JSON.parse(response)) {
                // !FIXME: Do this better!
                window.location.reload();
            }
        } catch (error) {
            showError(error);
        }
    }

    return (
        <Tooltip title={`Mark Holds as 'Processing'`}>
            <IconButton onClick={handleMarkAsProcessingClick}>
                <WatchLater />
            </IconButton>
        </Tooltip>
    );
}

export default memo(MarkHoldsAsProcessingButton);
